"use client";

import { Settings } from "luxon";
import React, { FC, memo, useRef } from "react";
import { useEffectOnce } from "react-use";
import { getApps, initializeApp } from "firebase/app";

import { ColorModeProvider } from "@components/ui/color-mode";
import { Provider as ChakraUIProvider } from "@components/ui/provider";
import { Toaster } from "@components/ui/toaster";
import { createRootStore, RootStoreProvider } from "stores/rootStore";
import firebaseConfig from "config/firebase";

interface Props {
  children: React.ReactNode;
}

const AppShell: FC<Props> = ({ children }) => {
  const rootStoreRef = useRef(createRootStore());

  useEffectOnce(() => {
    if (getApps().length === 0) {
      initializeApp(firebaseConfig);
    }
    Settings.defaultZone = "utc";
  });

  return (
    <ChakraUIProvider>
      <ColorModeProvider>
        <RootStoreProvider value={rootStoreRef.current}>
          {children}
          <Toaster />
        </RootStoreProvider>
      </ColorModeProvider>
    </ChakraUIProvider>
  );
};
AppShell.displayName = "AppShell";

export default memo(AppShell);
